import { useState, useRef, useCallback } from 'react';
import { useOutsideClick } from './useOutsideClick';

export const useDropdown = (defaultShow = false) => {
  const [open, setOpen] = useState(defaultShow);
  const ref = useRef(null);

  const toggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  useOutsideClick(ref, () => setOpen(false), open);

  return {
    open,
    setOpen,
    toggle,
    ref,
  };
};
